import React, { useState, useRef, useCallback } from "react";
import styles from "./instructions.module.scss";
import { Link } from "@reach/router";

function About(props) {
  return (
    <div className={styles.page}>
      <div className={styles.about}>
        <h1 className={styles.title}>About Non-Humans of Liverpool</h1>
        <p>
          Non-Humans of Liverpool is a collaborative work by artist Jack Tan,
          FACT's Digital Ambassadors (Anna Reid, Corinne Jones and Dot Jackman)
          young people from Liverpool (Evan Bray, Tia Hume-Jennings and Tom Oak)
          and FACT Learning Staff. It is a digital tool and game, and part of a
          wider art project called ‘Learning Non-Human’, that explores how we as
          humans learn about non-human perspectives and laws.
        </p>
        <p>
          2020 was FACT’s Year of the Living Planet, through which we joined the
          conversation about Climate Change and its impact on our environment.
          Environment is everything around us, encompassing all the conditions
          in which a person, animal, plant or ecosystem lives and operates. And
          yet only a few people have the power to “manage it”. So how can we
          take individual and collective responsibility for the other species
          that share our planet with us? How does Science, Technology and Art
          inform Climate Justice? How do we resolve conflicts between human and
          non-human laws and use of space or environmental resources?
        </p>
        <p>
          This art commission gave us the opportunity to talk about
          Intergenerational Climate Justice and how future human and non-human
          people will be affected by our current actions. It was an opportunity
          to enter into a learning process and indeed to learn how to learn
          about non-humans.{" "}
        </p>
        <p>
          We were inspired by Jack Tan’s ability to create playful spaces for
          participants to question how non-humans are considered, or not, in the
          plans and laws we make. We were interested to explore how his practice
          could create space for intergenerational learning online.
        </p>
        <p>
          This digital tool/game was co-created through a series of in depth
          artist-led workshops, delivered on Zoom throughout the 2020 pandemic.
          Participants engaged in world building and character development, role
          playing as the non-humans in Liverpool. They created and tested a game
          that rewards players for solving problems and creating policy ideas
          from the point of view of non-humans.
        </p>
        <p>
          Non-Humans of Liverpool, and the wider project Learning Non-Human, was
          commissioned by FACT as part of Young at Art, a partnership between
          FACT, Open Eye Gallery and National Museums Liverpool and funded by
          Arts Council England's Celebrating Age programme and The Baring
          Foundation and with support from Medicash Foundation.
        </p>
      </div>
      <nav>
        <ul className={styles.NavList}>
          <li className={styles.links}>
            <Link className={styles.linkButton} to={"/"}>
              HOME
            </Link>
          </li>
          <li className={styles.links}>
            <Link
              className={styles.linkButton}
              to={"/credits/" + props.alpha + "/" + props.type + ""}
            >
              VIEW CREDITS
            </Link>
          </li>
          <li className={styles.links}>
            <Link
              className={styles.linkButton}
              to={"/inst/" + props.alpha + "/" + props.type + ""}
            >
              WHAT MAKES A GOOD MARKER?
            </Link>
          </li>
          {props.type !== "undefined" && props.type && (
            <li className={styles.links}>
              <Link
                className={styles.linkButton}
                to={"/" + props.alpha + "/" + props.type + ""}
              >
                BACK TO MAP
              </Link>
            </li>
          )}
        </ul>
      </nav>
    </div>
  );
}

export default About;
